import {User} from "./user.model.ts";

export class LoginInfo {

    token: string;
    user: User;
    login_challenge: string;

    constructor() {

        this.token = '';
        this.user = new User();
        this.login_challenge = '';

    }

}

